import { useState } from 'react';
import { Text } from '@ui/atoms';
import { PlusIcon } from '@heroicons/react/solid';

const AccordionItem = ({ question, answer, haveInnerHtml = false }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="z-30 ">
            <div
                className={`flex gap-2 cursor-pointer items-baseline md:items-center`}
                onClick={() => setIsOpen((val) => !val)}
            >
                <PlusIcon
                    className={`inline duration-100 transition-transform !w-3 md:!w-5 shrink-0 ${
                        isOpen
                            ? 'rotate-45 text-primary-500 p4-semibold'
                            : 'text-gray-400 p4-medium'
                    }`}
                />
                <Text
                    className={`${
                        isOpen
                            ? 'text-primary-500 p4-semibold'
                            : 'text-gray-600 p4-medium'
                    }`}
                    content={question}
                    htmlTag="h4"
                />
            </div>

            <div className={`px-2 md:px-4 py-3 ml-3 md:ml-3 bg-transparent rounded-lg ${isOpen ? 'block' : 'hidden'}`}>
                <Text
                    content={answer}
                    className="text-primary-500 p4-regular"
                    isInnerHtml={haveInnerHtml}
                />
            </div>
        </div>
    );
};

export default AccordionItem;
